﻿//find an object within any browser
function _findObj(n, d) {
    var p, i, x;
    if (!d) d = document;
    if ((p = n.indexOf("?")) > 0 && parent.frames.length) { d = parent.frames[n.substring(p + 1)].document; n = n.substring(0, p); }
    if (!(x = d[n]) && d.all) x = d.all[n];
    if (!x && d.getElementById) x = d.getElementById(n);
    for (i = 0; !x && i < d.forms.length; i++) x = d.forms[i][n];
    for (i = 0; !x && d.layers && i < d.layers.length; i++) x = _findObj(n, d.layers[i].document);
    return x;
}
document.findObj = _findObj;
document.findElement = _findObj;